import { render, staticRenderFns } from "./dzpkTable.vue?vue&type=template&id=ad7b29dc&scoped=true"
import script from "./dzpkTable.vue?vue&type=script&lang=ts"
export * from "./dzpkTable.vue?vue&type=script&lang=ts"
import style0 from "./dzpkTable.vue?vue&type=style&index=0&id=ad7b29dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7b29dc",
  null
  
)

export default component.exports